import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CommonResponse } from '../../customs/_models/Response';
import { Endpoints } from '../../customs/endpoints';

export interface MatriceDTO {
  id: number;
  reference: string;
  nom: string;
  priseDEssai?: string;
  type: string;
  description: string;
  flag: number;
  creationDate?: string;
  updateDate?: string;
  createdBy?: any;
  matriceReglementaires: MatriceReglementaireDTO[];
}


export interface MatriceReglementaireDTO {
  id: number;
  productId: number;
  productName: string;
  productCode: string;
  updateDate?: string;
}

@Injectable({
  providedIn: 'root'
})
export class MatriceService {
  private baseUrl = this.endpoints.matrice_base_endpoint;

  constructor(private http: HttpClient, private endpoints: Endpoints) {}

  // Récupérer toutes les matrices
  public getAllMatrices(): Observable<CommonResponse> {
    return this.http.get<CommonResponse>(`${this.baseUrl}`);
  }

  getMatriceWithReglementaires(matriceId: number): Observable<MatriceDTO> {
    return this.http.get<MatriceDTO>(`${this.baseUrl}/${matriceId}/reglementaires`);
  }

  public fetchmatriceList(): Observable<CommonResponse> {
    console.log(this.endpoints.matrice_base_endpoint + "/findAllShorts")
    return this.http.get<CommonResponse>(this.endpoints.matrice_base_endpoint + "/findAllShorts")
}

  // Récupérer les matrices pour une liste déroulante (id et nom uniquement)
  public fetchMatriceList(): Observable<CommonResponse> {
    return this.http.get<CommonResponse>(`${this.baseUrl}/findAllShorts`);
  }

  // Récupérer les matrices créées par l'utilisateur connecté
  public getAllMatricesCreatedByUser(): Observable<CommonResponse> {
    return this.http.get<CommonResponse>(`${this.baseUrl}/get-by-created-user`);
  }

  // Récupérer une matrice par son ID
  public getMatriceById(id: number): Observable<CommonResponse> {
    return this.http.get<CommonResponse>(`${this.baseUrl}/${id}`);
  }

  // Créer une nouvelle matrice
  public createMatrice(matrice: MatriceDTO): Observable<CommonResponse> {
    return this.http.post<CommonResponse>(`${this.baseUrl}`, matrice);
  }

  // Mettre à jour une matrice existante
  public updateMatrice(id: number, matrice: MatriceDTO): Observable<CommonResponse> {
    return this.http.put<CommonResponse>(`${this.baseUrl}/${id}`, matrice);
  }

  // Supprimer une matrice

  public deleteMatrice(id: number): Observable<CommonResponse> {
    return this.http.delete<CommonResponse>(`${this.baseUrl}/${id}`);
  }

  public getTypes(): Observable<string[]> {
  return this.http.get<string[]>(`${this.baseUrl}/types`);
}
}


